import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles(theme => ({
  formControlLabel: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    fontSize: '0.875rem',
    userSelect: 'none'
  },
  label: {
    flexGrow: 1
  },
  count: {
    marginLeft: theme.spacing(2)
  },
  checkboxRoot: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem'
    }
  }
}));

const FilterPanelItem = ({ value, count, selected, onChange }) => {
  const classes = useStyles();
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={selected}
          onChange={onChange}
          value={value}
          classes={{
            root: classes.checkboxRoot
          }}
        />
      }
      label={
        <>
          <span className={classes.label}>{value}</span>
          <Chip size="small" label={count} classes={{ root: classes.count }} />
        </>
      }
      classes={{
        label: classes.formControlLabel
      }}
    />
  );
};

export default FilterPanelItem;
